import { paths } from '../../../common/constants/pathVariables.js';
import {
  billingAccountsMsg,
  billingMsg,
  businessSecurityMsg,
  companyDetailsMsg,
  contactInformationMsg,
  contractsMsg,
  deviceListsMsg,
  devicesMsg,
  fixedBroadbandMsg,
  instructionsMsg,
  internetSubscriptionsMsg,
  invitationsMsg,
  invoiceLettersMsg,
  invoicesMsg,
  licenseManagementMsg,
  messageCenterMsg,
  microsoft365Msg,
  mobiilivarmenneMsg,
  mobileBroadbandMsg,
  mobileM2MMsg,
  myAccountMsg,
  myServicesMsg,
  omatEdutMsg,
  orderHistoryMsg,
  ordersMsg,
  phoneSubscriptionMsg,
  quotesMsg,
  redeemRequestsMsg,
  reportsMsg,
  servicesMsg,
  settingsMsg,
  shopMsg,
  supportMsg,
  t,
  usersMsg,
  voiceSubscriptionsMsg,
} from '../../../common/i18n/index.js';
import { getActiveAccountMasterId } from '../../../selfservice/common/localStorageUtils';
import { navigationItemListWithCurrentProperty } from '../../Header/dynamic/headerFunctions.js';
import type { CLHeaderNestedSubMenu } from '../../../common/types/componentLibrary';

const omaElisaNavigationItemList = (
  mobileId: boolean,
  dnsManagementEnabled: boolean,
  cocoEnabled: boolean,
  cocoProposalManagementEnabled: boolean
): CLHeaderNestedSubMenu[] => {
  return [
    {
      title: t.AUI8(billingMsg),
      subMenu: [
        {
          title: t.Y7C0(invoicesMsg),
          url: paths.INVOICES,
        },
        {
          title: t.ZVMK(billingAccountsMsg),
          url: paths.BILLING_ACCOUNTS,
        },
        {
          title: t.OMMT(invoiceLettersMsg),
          url: paths.INVOICE_DOCUMENTS,
        },
      ],
    },
    {
      title: t.GCO3(orderHistoryMsg),
      subMenu: [
        {
          title: t.I9C0(ordersMsg),
          url: paths.CUSTOMER_ORDER_HOME,
        },
        {
          title: t.Z1M1(redeemRequestsMsg),
          url: paths.CUSTOMER_ORDER_REDEEM_REQUESTS,
        },
      ],
    },
    {
      title: t.OHZ1(myServicesMsg),
      subMenu: [
        {
          title: t.AR0B(voiceSubscriptionsMsg),
          url: paths.PS_MOBILE_SUBSCRIPTIONS,
        },
        {
          title: t.SEYV(internetSubscriptionsMsg),
          url: paths.PS_BROADBAND_SUBSCRIPTIONS,
        },
        {
          title: t.JJTM(devicesMsg),
          url: paths.PS_DEVICES,
        },
        {
          title: t.MBG9(servicesMsg),
          url: paths.PS_SERVICES,
        },
        ...(cocoEnabled && cocoProposalManagementEnabled
          ? [
              {
                title: t.J63R(quotesMsg),
                url: paths.PS_QUOTES,
              },
            ]
          : []),
        {
          title: t.PKEZ(mobiilivarmenneMsg),
          url: paths.PS_MOBILE_CERTIFICATE,
        },
        ...(mobileId
          ? [
              {
                title: t.SW0J(contractsMsg),
                url: paths.PS_CONTRACTS,
              },
            ]
          : []),
        {
          title: t.N689(licenseManagementMsg),
          url: paths.PS_LICENSES,
        },
        ...(dnsManagementEnabled
          ? [
              {
                title: 'Elisa DNS',
                url: paths.PS_ELISA_DNS,
              },
            ]
          : []),
      ],
    },
    {
      title: t.A1Q5('Company details and settings'),
      subMenu: [
        {
          title: t.L7QB(companyDetailsMsg),
          url: paths.COMPANY_INFO_HOME,
        },
        {
          title: t.EJQF(settingsMsg),
          url: paths.COMPANY_INFO_SETTINGS,
        },
        {
          title: t.BE4A(usersMsg),
          url: paths.COMPANY_INFO_CONTACTS,
        },
        {
          title: t.HFD9(invitationsMsg),
          url: paths.COMPANY_INFO_INVITES,
        },
        {
          title: t.COBB(deviceListsMsg),
          url: paths.COMPANY_INFO_CATALOGS,
        },
        {
          title: t.Y36X(reportsMsg),
          url: paths.COMPANY_INFO_REPORTS,
        },
        {
          title: t.SEBD(myAccountMsg),
          url: paths.COMPANY_INFO_MY_ACCOUNT,
        },
      ],
    },
    {
      title: t.VUU0(supportMsg),
      subMenu: [
        {
          title: t.O5C5(messageCenterMsg),
          url: paths.MESSAGE_CENTER_SUPPORT_CASES,
        },
        {
          title: t.GJS9(contactInformationMsg),
          url: paths.CONTACT_INFO,
        },
        {
          title: t.RD4R(instructionsMsg),
          url: paths.INSTRUCTIONS,
        },
      ],
    },
    {
      title: t.BZYZ(shopMsg),
      subMenu: [
        {
          title: t.JJTM(devicesMsg),
          url: paths.WEB_SHOP,
        },
        {
          title: t.R6AR(phoneSubscriptionMsg),
          url: `${paths.PS_MOBILE_SUBSCRIPTION_NEW}${'?mdmId=' + getActiveAccountMasterId()}`,
        },
        {
          title: t.QXQ7(fixedBroadbandMsg),
          url: paths.ANONYMOUS_FIXED_BROADBAND_ORDER,
        },
        {
          title: t.EQKJ(mobileBroadbandMsg),
          url: `${paths.PS_BROADBAND_SUBSCRIPTION_NEW}${'?mdmId=' + getActiveAccountMasterId()}`,
        },
        {
          title: t.A7CA(mobileM2MMsg),
          url: `${paths.PS_BROADBAND_SUBSCRIPTION_NEW_M2M}${'?mdmId=' + getActiveAccountMasterId()}`,
        },
        {
          title: t.MV3J(microsoft365Msg),
          url: paths.MICROSOFT_365,
        },
        {
          title: t.AV0P(businessSecurityMsg),
          url: paths.BUSINESS_SECURITY,
        },
        {
          title: t.SLPO(omatEdutMsg),
          url: paths.MY_OFFERS,
        },
      ],
    },
  ];
};

export const omaElisaNavigationLinksWithCurrentProperty = (
  mobileId: boolean,
  currentPath: string,
  dnsManagementEnabled: boolean,
  cocoEnabled: boolean,
  cocoProposalManagementEnabled: boolean
): CLHeaderNestedSubMenu[] => {
  return navigationItemListWithCurrentProperty(
    omaElisaNavigationItemList(mobileId, dnsManagementEnabled, cocoEnabled, cocoProposalManagementEnabled),
    currentPath
  );
};
